export default __webpack_public_path__ + "static/media/medium.d7821c8a.svg";